import React, { useState, useEffect } from "react";
import { getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
export const useQuestionOptions = (question, onOptionsLoaded, isEmployee) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const needsFetch =
      ["select", "multiselect"].includes(
        question.questionType || question.fieldType,
      ) &&
      question.options &&
      question.options.length > 0 &&
      typeof question.options[0] === "string";

    if (needsFetch) {
      const load = async () => {
        setLoading(true);
        try {
          const apiUrl = isEmployee
            ? API_URLS.GET_QUESTION_OPTIONS(question._id)
            : API_URLS.GET_CUSTOMER_FORM_QUESTION_OPTIONS(question._id);

          const res = await getApi({ apiUrl });
          if (res && res.success) {
            setOptions(res.data);
            if (onOptionsLoaded) {
              onOptionsLoaded(question.questionId, res.data);
            }
          }
        } catch (err) {
          console.error(`Failed options load ${question.questionId}`, err);
        }
        setLoading(false);
      };
      load();
    } else {
      const opts = question.options || [];
      setOptions(opts);
      if (onOptionsLoaded && opts.length > 0) {
        onOptionsLoaded(question.questionId, opts);
      }
    }
  }, [question._id, question.options]);

  return { options, loading };
};

export const getOptionLabel = (questionId, optionValue, optionsCache) => {
  const cached = optionsCache?.[questionId];
  if (cached && Array.isArray(cached)) {
    const found = cached.find(
      (opt) =>
        String(opt.value).trim().toLowerCase() ===
        String(optionValue).trim().toLowerCase(),
    );
    if (found) return found.label;
  }
  return optionValue;
};
